import { colorsTuple, createTheme, MantineThemeOverride } from '@mantine/core'
import { ActionIcon, Avatar, Button, Container, Loader, Modal, Tabs } from './mantine'

const theme: MantineThemeOverride = createTheme({
	components: {
		Modal,
		Container,
		Button,
		Avatar,
		ActionIcon,
		Tabs,
		Loader,
	},
	fontFamily: "'Source Han Sans VF', 'Noto Color Emoji', system-ui, sans-serif",
	colors: {
		yellow: colorsTuple(Array(10).fill('var(--tint-jike-yellow)')),
	},
	primaryColor: 'yellow',
})

export default theme
